module.exports = __webpack_public_path__ + "static/media/claudio.ad68bd3e.jpg";